<table class="table">
  <thead>
    <tr>
      <th>{{ "common.productVariant" | translate }}</th>
      <th>{{ "requestPurchase.sku" | translate }}</th>
      <th>{{ "Expected date" | translate }}</th>
      <th>{{ "inbounding.remainingDays" | translate }}</th>
      <th>{{ "Quantity Needed" | translate }}</th>
      <th>{{ "Quantity Fulfilled" | translate }}</th>
    </tr>
  </thead>
  <tbody *ngIf="item">
    <tr *ngFor="let request of item.group.requests">
      <td class="flex flex-row">
        <a
          class="button-ghost"
          [routerLink]="[
            '/catalog/products',
            request.productVariant.product.id
          ]"
        >
          <span>
            {{ request.productVariant.name }}
          </span>
          <clr-icon shape="arrow right" />
        </a>

        <div
          *ngIf="request.productVariant.product.customFields.freeGifts"
          class="freegift-badge button-ghost"
        >
          Free gift <clr-icon shape="shopping-bag" />
        </div>
      </td>
      <td>{{ request.productVariant.sku }}</td>
      <td *ngIf="request.expectedDate">
        {{ request.expectedDate | localeDate : "short" }}
      </td>
      <td *ngIf="!request.expectedDate">*</td>

      <td>{{ request.daysLate }}</td>
      <td>
        {{
          (request.notSpecify
            ? "requestPurchase.not-specify-stock"
            : request.quantityNeeded
          ) | translate
        }}
      </td>
      <td>{{ request.quantityFulfilled }}</td>
    </tr>
  </tbody>
</table>
